import { useEffect, useState, useContext, useRef } from "react";
import { CurrentPContext, UserContext } from "../../../ContextApi/context";
import ConnUrls from "../../../Connections/ConnectURL";
import { Link } from "@mui/material";


const AppsLinksePage = (props) => {

    const [loading, setLoading] = useState(false);


    useEffect(() => {
    }, [])


    return (
        <>
            {!loading && (
                <div className="appslInkPop">
                    <div className={"landingFullBG"}
                        style={{ backgroundImage: props.BgSet }}>

                    </div>

                    <div className="landingContent">
                        <div className="landingIN">

                            <div className={"mainHd"}>{props.theSingle.firstMark?.head}</div>
                            <div className={"smallTxt"}>{props.theSingle.firstMark?.smText}</div>
                            <div className={"mainHd"}>{props.theSingle.secondMark?.head}</div>
                            <div className={"smallTxt"}>{props.theSingle.secondMark?.smText}</div>

                            {
                                props.theSingle.landPbtns?.map((btnItm, index) => {
                                    return (
                                        <a key={index} href={btnItm.link}>
                                            <div className="lnkBtn">
                                                {btnItm.icon ? <img className={'smallImgBtn onLeft'} src={`${ConnUrls.media(btnItm.icon)}`} alt={"Icon"} /> : null}
                                                <p className={''}>{btnItm.text}</p>
                                            </div>
                                        </a>
                                    )
                                })}

                            {
                                props.theSingle.landPLogos?.map((btnItm, index) => {
                                    return (
                                        <a key={index} href={btnItm.link}>
                                            <div className={"btnLogoWrap"} style={{ width: btnItm.width ? btnItm.width + "%" : "70%" }}>
                                                {btnItm.logo ? <img className={"ashdodMnuLogo"} src={`${ConnUrls.media(btnItm.logo)}`} alt={"itemLogo"} />
                                                    : null}
                                            </div>
                                        </a>
                                    )
                                })}
                            {/* <a href={"https://www.ashdodmenu.co.il/"}>
                                <div className={"ashdodMnuLogoWrap"}>
                                    <img className={"ashdodMnuLogo"} src={`${ConnUrls.media('Uploads/MASTER/mainLogo55.png')}`} alt={"ashdodMnuLogo"} />
                                </div>
                            </a> */}

                        </div>
                    </div>

                </div >
            )}
            <style jsx>{`
           
                .landingIN {    
                    position: relative;
                    top: 240px;
                    z-index: 1;
                    width: 100%;
                    margin: 0 auto;
                }
                .mainHd
                {
                    color: black;
                    text-align: center;
                    font-weight: bold;
                    font-size: 2.3rem;
                    line-height: 1;

                }
                .smallTxt
                {
                    color: black;
                    text-align: center;
                    font-weight: regular;
                    font-size: 1.7rem;
                    line-height: 2rem;
                    margin-bottom: 20px;

                }
                .lnkBtn
                {
                    text-align:center;
                    font-weight:regular;
                    font-size: 1.0rem;
                    padding:10px 5px;
                    margin: 10px auto;
                    background-color:black;
                    position:relative;
                    border-radius:10px;
                    width:70%;
                    

                }
                .smallImgBtn
                {
                    width:20px;                    
                    left:25px;
                    position:absolute;
                }
                .lnkBtn p
                {
                    color:white !important;
                }
                .ashdodMnuLogoWrap
                {
                    margin: 35px auto;
                    text-align: center;
                    width: 55%;
                }
                .btnLogoWrap
                     {
                    margin: 35px auto;
                    text-align: center;
                    overflow:hidden;
                }
                .ashdodMnuLogo
                {
                    width:100%;
                    height:100%;
                }
            `}

            </style>
        </>
    )
}

export default AppsLinksePage;
